<template>
    <div class="normal-container py-5 lg:py-10">
        <div
            class="normal-container flex flex-col lg:flex-row lg:items-center lg:gap-28"
            :class="{
                'flex-col lg:flex-row-reverse': image.imageLeft,
                'flex-col': !image.imageLeft,
            }">
            <div class="sanity-content sanity-content-image w-full lg:mb-5">
                <SanityContent :blocks="body" :serializers="serializers" />
            </div>
            <div class="relative mb-6 w-full lg:mb-5">
                <div
                    :class="{
                        'bg-green-800': vercelStegaCleanAll(image.imageBoxShadow) === 'solid',
                        'border-2 border-green-800': vercelStegaCleanAll(image.imageBoxShadow) === 'border',
                    }"
                    class="box-shadow-size absolute bottom-0 right-0 rounded-br-[40px] lg:rounded-br-3xl"></div>
                <div
                    :class="{
                        'bg-green-500': vercelStegaCleanAll(image.imageBoxShadow) === 'solid',
                        'border-2 border-green-500': vercelStegaCleanAll(image.imageBoxShadow) === 'border',
                    }"
                    class="box-shadow-size absolute left-0 top-0 rounded-tl-[40px] lg:rounded-tl-3xl"></div>
                <NuxtImg
                    v-if="image"
                    :alt="image.imageAlt"
                    :src="useImageUrl(image).url()"
                    :class="imageClass"
                    class="relative z-10 h-full w-full object-cover px-6 py-6 lg:mb-0" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { vercelStegaCleanAll } from '@sanity/client/stega';

    const props = defineProps({
        image: Object,
        body: Object,
    });

    const imageClass = computed(() => {
        switch (props.image.imageFormat) {
            case 'square':
                return 'aspect-w-1 aspect-h-1 h-auto w-auto';
            case 'rectangleVertical':
                return 'min-h-[600px] !aspect-w-9 !aspect-h-16';
            default:
                return 'lg:min-h-[600px]';
        }
    });

    const serializers = {
        types: {
            button: resolveComponent('Button'),
        },
    };
</script>

<style scoped>
    .box-shadow-size {
        width: calc(100% - 50px);
        height: calc(100% - 50px);
    }
</style>
